import cn from 'classnames';

// Components & Styles
import Maybe from '@components/Maybe';
import WalledGarden from '@components/WalledGarden';
import LegalSection from '../Parts/LegalSection';
import SiteLinks from '../Parts/SiteLinks';

/* Queries */
import usePartnerQueryCache from '@integrations/partners/usePartnerQuery.cache';

/* Styles */
import styles from '../footer.module.scss';
import { PartnerBaseAttributes, PartnerClient } from '@integrations/partners/partners.types';

const footerStyles = cn(styles.footerContainer);

const DefaultFooter = ({ partner }: { partner?: PartnerBaseAttributes }) => {
  /* There are times a page cata omits the partner (admin setup) but we are in a partner flow. */
  const cachedPartner = usePartnerQueryCache();
  const partnerData = (partner || cachedPartner) as PartnerClient;

  return (
    <footer className={footerStyles} data-testid="standard-footer">
      <Maybe condition={!partnerData?.id || partnerData?.footerSiteLinks}>
        <WalledGarden condition={Boolean(1)}>
          <SiteLinks />
        </WalledGarden>
      </Maybe>
      <Maybe condition={!partnerData?.id || partnerData?.footerLegalLinks}>
        <LegalSection partner={partnerData} />
      </Maybe>
    </footer>
  );
};

export default DefaultFooter;
/*
  DefaultFooter: The footer to be displayed across the site
  PartnerFooter: A lighter version of Default Footer

  Notes:
    - For now, we derive if its a partners via the partners object.
*/
